import displayFlash from "partners/scripts/display_flash"

export default function archiveApplet(url) {
  update(url, true)
    .then(function () {
      displayFlash("Applet archived")
      window.location.assign("") // soft refresh
    })
    .catch(function () {
      displayFlash("Your Applet could not be archived", "error")
    })
}

export function unarchiveApplet(url) {
  update(url, false)
    .then(function () {
      displayFlash("Applet unarchived")
      window.location.assign("") // soft refresh
    })
    .catch(function () {
      displayFlash("Your Applet could not be unarchived", "error")
    })
}

function update(url, archived) {
  return fetch(url, {
    method: "PUT",
    body: JSON.stringify({
      applet: { archived },
      authenticity_token: window.App.authenticityToken,
    }),
    headers: { "Content-Type": "application/json" },
  }).then(response => response.json())
}
